import React, { ReactElement } from 'react';
import ListItem from '../list-item/list-item.component';
import LongClickItem from '../long-click-item/long-click-item.component';

const LongClickListItem: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    isButton,
    isActive,
    isExtended,
    isCompleted,
    children,
    ...custom
  } = props;

  return (
    <LongClickItem
      component={ListItem}
      componentProps={{
        isButton,
        isActive,
        isExtended,
        isCompleted,
      }}
      {...custom}
    >
      {children}
    </LongClickItem>
  );
});

export default LongClickListItem;
